<template>
  <div>
    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        :key="index"
        v-for="(lesson, index) in localValue"
      >
        <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
          <div class="collapse-item">
            <div
              class="flex justify-between header"
              slot="header"
              @click="lesson.isCollapseCard = !lesson.isCollapseCard"
              :class="{ activeCollapse: lesson.isCollapseCard }"
            >
                            <div v-if="lesson.name == ''">Lesson {{index + 1}}</div>
                <div v-else>{{lesson.name}}</div>
              <!-- <h5>{{ lesson.name }}</h5> -->
              <span class="material-icons">keyboard_arrow_down</span>
            </div>
            <div
              class="collapseContent"
              v-show="lesson.isCollapseCard"
              :class="{ active: lesson.isCollapseCard }"
            >
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-input
                    class="w-full mt-5"
                    placeholder="Title"
                    v-model="lesson.name"
                    v-validate="'required'"
                    name="Title"
                    data-vv-name="Title"
                  />
                </vs-col>
                <span
                  v-show="errors.has('CourseBuilder.Title')"
                  class="text-danger block"
                  >{{ errors.first('CourseBuilder.Title') }}</span
                >
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-textarea
                    class="w-full mt-5"
                    label="Description"
                    v-model="lesson.description"
                    :name="`Description${index}`"
                  />
                </vs-col>
                <span
                  v-show="errors.has(`CourseBuilder.Description${index}`)"
                  class="text-danger block"
                  >{{ errors.first(`CourseBuilder.Description${index}`) }}</span
                >
              </vs-row>

                <content-component
                v-model="lesson.content.content"
                v-if="lesson.showCourseContent"
                label="Content"
                                :file_repository_id="file_repository_id"

              ></content-component>

              <!-- Topics -->

              <topic-component
                v-model="lesson.topics"
                :file_repository_id="file_repository_id"
              ></topic-component>

        
              <!-- File Upload Component -->
              <file-upload
                v-if="lesson.showFileContent"
                section_type="lessonComponent"
                :multiplefile="true"
                @getFileId="getIdFile"
                @deletedIndex="deletedIndex"
                :lesson_file_index="index"
                :file_repository_id="file_repository_id"
                :filesInfo="lesson.filesInfo"
              ></file-upload>

             <!--  <vs-card>
                {{lesson.file_ids}}
              </vs-card> -->

              <!-- <div v-if="lesson.filesInfo">
                <file-showing :filesInfo="lesson.filesInfo"
                          :file_ids="lesson.file_ids"

                ></file-showing>
              </div> -->

              <!-- File Upload Component -->
              <vs-row vs-type="flex" vs-justify="space-around">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="12"
                >
                  <vs-button
                    color="primary"
                    @click="addTopic(lesson)"
                    icon-pack="feather"
                    icon="icon-plus-circle"
                    type="flat"
                    >Topic</vs-button
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="12"
                >
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-plus-circle"
                    type="flat"
                    @click="
                      lesson.showCourseContent = !lesson.showCourseContent
                    "
                    >Content</vs-button
                  >
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="12"
                >
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-plus-circle"
                    type="flat"
                    @click="lesson.showFileContent = !lesson.showFileContent"
                    >Attach File</vs-button
                  >
                </vs-col>
              </vs-row>

              <div class="lesson-import">
                <import-module
                  :subjects="subjects"
                  @openQuestionModal="importQuesionModal"
                  :lesson_file_index="index"
                  types="lessons"
                ></import-module>
              </div>

              <!-- Assignment Components -->

              <vs-row v-if="lesson.imported_question_details.length">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
                  <vs-card>
                    <ImportedQuestionsComponent
                      :question_details="lesson.imported_question_details"
                      :lesson_file_index="index"
                      @removeImportedQuestionsEvent="
                        removeImportedLessonQuestions
                      "
                    >
                    </ImportedQuestionsComponent>
                  </vs-card>
                </vs-col>
              </vs-row>
              <vs-row v-if="lesson.imported_assignment_details.length">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
                  <vs-card>
                    <imported-assignments-component
                      v-if="course"
                      :assignmentDataList="lesson.imported_assignment_details"
                      @removeImportedAssignmentEvent="
                        removeImportedLessonAssignment
                      "
                      :lesson_file_index="index"
                    >
                    </imported-assignments-component>
                  </vs-card>
                </vs-col>
              </vs-row>
              <!-- Assignment Components -->

              <vs-row vs-type="flex" vs-justify="space-around">
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="center"
                  vs-w="10"
                >
                  <vs-checkbox v-if="section_type !== 'Lessons'" v-model="lesson.is_visible"
                    >Save to lesson List</vs-checkbox
                  >
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="0.4"
                >
                  <vs-button
                    v-if="section_type != 'Lessons'"
                    @click="removeCard(index)"
                    color="danger"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    type="flat"
                  ></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <div v-if="isQuestionModal">
      <vs-popup fullscreen title="fullscreen" :active.sync="isQuestionModal">
        <question-modal
          :subject_id="subjects"
          @closeQuestionBank="closedLessonBank"
        ></question-modal>
      </vs-popup>
    </div>

    <div v-if="isAssignmentModal">
      <vs-popup
        v-if="isAssignmentModal"
        fullscreen
        title="fullscreen"
        :active.sync="isAssignmentModal"
      >
        <assignment-model
          :subject_ids="subjects"
          :assignment_type_id="assignment_type_id"
          @getAssignmentData="getLessonimportedAssignmentData"
          type="lessons"
        ></assignment-model>
      </vs-popup>
    </div>

    <div v-if="isTopicModal">
      <vs-popup fullscreen title="fullscreen" :active.sync="isTopicModal">
        <import-topic-model
          @getTopicList="getTopicimportedAssignmentData"
          type="lessons"
          :subject_ids="subjects"
        ></import-topic-model>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { Testing } from '../mixins/testing-mixin'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import TopicComponent from './TopicComponent'
import FileUpload from './FileUploadComponent.vue/FileUpload.vue'
import FileShowing from './FileUploadComponent.vue/FileShowing.vue'

import ImportModule from './Importing/ImportModule.vue'
import QuestionModal from '../../questions/question-modal.vue'
import AssignmentModel from './Importing/AssignmentModel.vue'
import ImportTopicModel from './Importing/ImportTopicModel.vue'

import ImportedQuestionsComponent from './ImportedQuestionsComponent.vue'
import ImportedAssignmentsComponent from './ImportedAssignmentsComponent.vue'

export default {
  inject: {
    $validator: '$validator'
  },
  props: {
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    subjects: {
      type: Array,
      default: () => []
    },
    section_type: {
      required: true,
      type: String,
      default: 'Course'
    },
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    }
  },

  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      aas: '',
      isQuestionModal: false,
      isAssignmentModal: false,
      isTopicModal: false,
      assignment_id: '', //2 homework, 4 exams, 3 reports etc

      lesson_file_index: null
    }
  },
  mixins: [Testing],
  components: {
    ContentComponent,
    TopicComponent,
    FileUpload,
    ImportModule,
    QuestionModal,
    ImportedQuestionsComponent,
    ImportedAssignmentsComponent,
    AssignmentModel,
    ImportTopicModel,
    FileShowing
  },
  methods: {
    toggle (index) {
      this.collapseCard = !this.collapseCard
      (index)
    },
    removeCard (index) {
      if (this.section_type === 'Lessons') {
        this.$vs.notify({
          title: 'Can\'t Perform',
          text: 'For Lesson Tab there should be atleast one lesson associate',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
        return true
      }
      setTimeout(() => {
        this.localValue.splice(index, 1)
        this.$vs.notify({
          title: 'Success',
          text: 'Lesson deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

      }, 1000)
    },
    getIdFile (obj) {

      if (Array.isArray(obj.file_id)) {

        this.localValue[obj.lesson_file_index].file_ids =  [...this.localValue[obj.lesson_file_index].file_ids, ...obj.file_id]

        
      } else {

        this.localValue[obj.lesson_file_index].file_ids.push(obj.file_id)
        
      }
      
    },
    deletedIndex (fileObject) {
      this.localValue[fileObject.lesson_file_index].filesInfo.splice(fileObject.fileIndex, 1)
      this.localValue[fileObject.lesson_file_index].file_ids.splice(fileObject.fileIndex, 1)

      
    },
    
    addTopic (lesson) {
    
      lesson.topics.push({
        name: '',
        description: '',
        subject_ids: [],
        assignment_ids: [],
        question_ids: [],
        content: {
          content: ''
        },
        file_ids: [],
        showCourseContent: false,
        showFileContent: false,
        isCollapseCard: false,
        filesInfo: [],
        imported_assignment_details: [],
        imported_question_details: [],
        is_visible: false
      })

      //   this.localvalue.push({
      //     courseTitle: '',
      //     courseDescription: ''
      //   })
    },

    importQuesionModal (obj) {
      if (this.subjects.length > 0) {
        if (obj.name === 'isQuestionModal') {
          this.isQuestionModal = true
        } else if (obj.name === 'isLessonModal') {
          this.isLessonModal = true
        } else if (obj.name === 'isTopicModal') {
          this.isTopicModal = true
        } else {
          this.isAssignmentModal = true
          this.assignment_type_id = obj.id
        }
        this.lesson_file_index = obj.lesson_file_index
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'You must select atleast 1 subject',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
        // this.showSuccessMessage('Warning', '', '') //title,success_text, color
      }
    },
    getLessonimportedAssignmentData (singleAssignmentObject) {
      
      singleAssignmentObject.forEach((ele) => {
        this.localValue[
          this.lesson_file_index
        ].imported_assignment_details.push({
          id: null,
          assignment: {
            id: ele.id,
            assignment_type_obj: ele.assignment_type_obj,
            subject: ele.subject,
            questions: ele.questions,
            title: ele.title,
            description: ele.description
          },
          status: true
        })
      })
      this.localValue[this.lesson_file_index].assignment_ids = this.localValue[
        this.lesson_file_index
      ].imported_assignment_details.map((ele) => {
        return ele.assignment.id
      })

      setTimeout(() => {
        this.isAssignmentModal = false
      }, 1000)
      // this.isAssignmentModal = false
      // (obj)
    },
    getTopicimportedAssignmentData (importedTopicObject) {
      // (object)
      importedTopicObject.forEach((editing_object) => {
       

        this.localValue[this.lesson_file_index].topics.push({
          id: editing_object.id,
          name: editing_object.name,
          description: editing_object.description,
          subject_ids: [],
          assignment_ids: [],
          question_ids: [],
          content: {
            id: editing_object.topicContent.id ? editing_object.topicContent.id : null,
            content: editing_object.topicContent.content ? editing_object.topicContent.content : ''
          },
          file_ids: [],
          showCourseContent: false,
          showFileContent: false,
          isCollapseCard: false,
          filesInfo: editing_object.topicFiles,
          is_imported: true
        })
      })

      setTimeout(() => {
        this.isTopicModal = false
      }, 1000)
    },
    closedLessonBank (importedQuestionObject) {

      // (this.lesson_file_index)
      const newQuestionArray = importedQuestionObject.map((ele) => {
        return {
          id: null,
          questions: {
            id: ele.id,
            title: ele.question_title,
            subject: ele.subject,
            input_type_id_obj: ele.input_type_id_obj,
            files: ele.file,
            links: ele.links,
            questions_options: ele.option,
            questions_answers: ele.answers,
            point: ele.point,
            feedback: ele.answerfeedback
          }
        }
      })
      this.localValue[this.lesson_file_index].imported_question_details.push(
        ...newQuestionArray
      )

      this.localValue[this.lesson_file_index].question_ids = this.localValue[
        this.lesson_file_index
      ].imported_question_details.map((ele) => {
        return ele.questions.id
      })

      // setTimeout()
      setTimeout(() => {
        this.isQuestionModal = false
      }, 1000)
      // this.isQuestionModal = false
    },
    removeImportedLessonQuestions (removeObject) {
      if (removeObject.type === 'allDelete') {

        setTimeout(() => {
          this.imported_assignment_details = []
          this.assignment_ids = []

          this.localValue[removeObject.lesson_file_index].question_ids = []
          this.localValue[
            removeObject.lesson_file_index
          ].imported_question_details = []
        }, 1000)
      } else {
       

        setTimeout(() => {
          this.localValue[removeObject.lesson_file_index].question_ids.splice(
            removeObject.removeIndex,
            1
          )
          this.localValue[
            removeObject.lesson_file_index
          ].imported_question_details.splice(removeObject.removeIndex, 1)
        }, 1000)
      }
    },
    removeImportedLessonAssignment (removeObject) {
      // (this.localValue[removeObject.lesson_file_index].question_ids)
      if (removeObject.type === 'allDelete') {
        setTimeout(() => {
          this.localValue[removeObject.lesson_file_index].assignment_ids = []
          this.localValue[
            removeObject.lesson_file_index
          ].imported_assignment_details = []
        }, 1000)
      } else {
        setTimeout(() => {
          this.localValue[removeObject.lesson_file_index].assignment_ids.splice(
            removeObject.removeIndex,
            1
          )
          this.localValue[
            removeObject.lesson_file_index
          ].imported_assignment_details.splice(removeObject.removeIndex, 1)
        }, 1000)
      }
    }
  }
}
</script>
<style>
img {
  max-width: 100%;
}
video {
  max-width: 100%;
}
.lesson-import .con-vs-card {
  width: 40%;
  margin: 20px auto;
}
.lesson-import .vs-card--content {
  padding: 5px 20px;
}
.lesson-import .import-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lesson-import
  .import-btn
  .con-vs-tooltip:not(:last-child)
  .import_icon_holder {
  border: none;
}
</style>